'use strict';

(function () {
  'use strict';

  angular.module('msCore').component('searchBar', {
    bindings: {
      // Function to call after search
      searchSuccess: '&',
      // If the query is passed in, a search will be kicked off on load.
      query: '<',
      // filters used to limit search results
      filters: '<',
      // size of result set to return (pagination)
      size: '<',
      // result page to return (pagination)
      from: '<',
      // To filter or not to filter
      showFilter: '<'
    },
    templateUrl: 'vnext/pages/components/searchBar.html',
    controller: SearchBarController
  });
  SearchBarController.$inject = ['$log', 'activitySvc', 'context', 'MetadataSvc', 'focus'];

  function SearchBarController($log, activitySvc, context, MetadataSvc, focus) {
    var vm = this;
    vm.search = search;
    vm.queryPopulated = queryPopulated;
    vm.$onInit = init;

    ///////////////////////////////

    function init() {
      focus.byId('search-input');
    }

    function queryPopulated() {
      return vm.searchTerms && vm.searchTerms.length > 0;
    }

    function search(query) {
      if (angular.isUndefined(query) || query === null || query.replace(/\s/g, '').length === 0) {
        return;
      }
      var searchBody = {
        query: query,
        context: context,
        filters: vm.filters,
        size: vm.size,
        from: vm.from
      };
      activitySvc.search(searchBody).then(function (resp) {
        // search complete
        vm.searchPending = false;
        if (vm.searchSuccess) {
          vm.searchSuccess({ data: { body: searchBody, results: resp } });
        } else {
          $log.warn('No callback specified to handle search results');
        }
      });
    }
  }
})();